<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/139wmVF/tc-custom/9780990635215.jpg?1725275974799" alt="This image is the cover for the book Bruja, Alpha Girls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bruja, Alpha Girls
      </h1>
      <p class="bookDescription body article font2">
        <b>From <i>USA Today</i> Bestselling Author Aileen Erin </b><br/><br/>Claudia de Santos has always looked out for every witch but herself. She fought from the shadows as her coven turned dark, and with a little help from her half-witch/half-Alpha werewolf cousin, Teresa McCaide, Claudia is doing everything she can to keeper friends and family in the light. <br/> <br/>Now the coven has splintered into two factions: Luciana’s army of witches wielding dark magic, and Claudia’s few stragglers who fight with the wolves. War is coming, and it won’t be much of a battle if Claudia can’t find the spells to counteract Luciana’s demonic power. But Luciana strikes before they’re prepared, and Claudia’s twin brother pays the price. Suddenly, going to Peru in search of ancient Incan magic doesn’t seem so crazy. <br/> <br/>Fighting evil will require a pure spirit, but her quest is full of temptations, including a handsome Peruvian guide with secrets of his own. Finding love is the last thing on Claudia’s ever-growing to-do list, but sometimes what you need has a way of seeking you out.<br/><br/><b> “Holy Moly! I loved it. Claudia’s trek to Peru is one helluva ride... I think I have a new favorite witch!”</b> —<i> Barb, Paging Through The Days</i><br/><br/><b>"It’s like the characters reach out of the book grab you by the scruff of the neck and drag you through the pages. Honestly, I don’t give up sleep for very many books but I just couldn’t put this one down.”</b> - <i>Ian, Goodreads</i><br/><br/><br/>It's time to binge the complete <b><i>Alpha Girls</i></b> series! <br/><br/>Book 1: <b>Becoming Alpha</b>, which hit #1 at all major eBook retailers<br/>Book 2: <b>Avoiding Alpha</b><br/>Book 3: <b>Alpha Divided</b>, an <i>USA Today</i> Bestseller<br/>Book 4: <b>Bruja</b><br/>Book 5: <b>Alpha Unleashed</b>, an <i>USA Today</i> Bestseller<br/>Book 6: <b>Shattered Pack</b><br/>Book 7: <b>Being Alpha</b><br/>Book 8: <b>Lunar Court</b><br/>Book 9: <b>Alpha Erased</b><br/><br/><b>Get ready for <b><i>Off Planet</i></b>, the biggest and boldest adventure yet from the mind of Aileen Erin. It's perfect for fans of Suzanne Collins' <b><i>The Hunger Games</i></b>, Claudia Gray's <b><i>Defy the Stars</i></b>, and Maura Milan's <b><i>Ignite the Stars</i></b>!<br/></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aileen Erin
      </h2>
      
      <p class="authorDescription body article"><i>USA Today</i> Bestselling Author Aileen Erin is half-Irish, half-Mexican, and 100% nerd—from Star Wars (prequels don’t count) to Star Trek (TNG FTW). She geeks out on Tolkien's linguistics, and has a severe fascination with the supernatural. Aileen has a BS in Radio-TV-Film from the University of Texas at Austin, and an MFA in Writing Popular Fiction from Seton Hill University. She lives with her husband and daughter in Los Angeles, and spends her days doing her favorite things: reading books, creating worlds, and kicking ass. <br><br>Aileen is the author of the <b>Aunare Chronicles</b>, a scifi action romance series, and the wildly loved YA paranormal <b>Alpha Girls</b> series. She's excited to annouce her upcoming YA paranormal series the <b>Days of Iron and Clay</b>. This new series follows Samantha Lopez, the resident demonologist from the Alpha Girls books. Samantha's first appearance can be found in <i>Being Alpha</i>, Book Seven of the Alpha Girls series.<br><br>Aileen's fans call her stories <b>"jaw dropping," "electrifying," "amazing,"</b> and <b>"bloody brilliant."</b> Bloggers say <b>"Erin's world-building is excellent and her characters are big and bold"</b>(Escape Into Worlds) and every book is <b>"a magnet that just keeps pulling until you feel as if you are falling down, down, down right into its world"</b> (Tempest of Books). Aileen Erin is the founder and CEO of Ink Monster, building worlds filled with girl power and happily ever afters.  You can find her at www.aileenerin.com or on Instagram @aileenerin.</p>
      
      
         <a class="authorURL body link" href="http://inkmonster.net/authors/aerin" target="_blank">
      
              About Author
         </a>
         <br/>
      
         <a class="authorURL body link" href="https://www.facebook.com/aelatcham" target="_blank">
      
              More  About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ink Monster
     </h2>
        
        
     <a class="publisherURL body link" href="http://inkmonster.net/" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     <a class="publisherURL body link" href="http://inkmonster.net/blog" target="_blank">
  
          More  About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bac3e1e